import React, { useState } from 'react';
import useSound from 'use-sound';
import ControlPanel from './ControlPanel/ControlPanel';
import Display from './Display/Display';
import './App.css';
import JVC_Logo from './Assets/JVC_Logo.svg';
import Tape from './Tape/Tape';

import clickSound from './Sounds/click.mp3';
import playSound from './Sounds/play-audio.mp3';
import ejectSound from './Sounds/eject.mp3';
import tapeInSound from './Sounds/tape-in.mp3';
import rewindSound from './Sounds/rewind.mp3';
import rewindFastSound from './Sounds/rewind-fast.mp3';
import errorSound from './Sounds/error.mp3';


const States = {
  Aus_leer: { An_leer: 'operate', Aus_mit_Tape: 'tape_in' },
  An_leer: { Aus_leer: 'operate', An_mit_Tape: 'tape_in' },
  Aus_mit_Tape: { An_mit_Tape: 'operate', Aus_leer: 'eject' },
  An_mit_Tape: { Wiedergabe: 'play', Aufnahme_normal: 'record', An_leer: 'eject', Aus_mit_Tape: 'operate', Vorspulen_schnell: 'fast_forward', Zurueckspulen_schnell: 'rewind' },
  Wiedergabe: { Aus_mit_Tape: 'operate', Zurueckspulen_normal: 'rewind', Vorspulen_normal: 'fast_forward', Pausieren: 'pause', An_mit_Tape: 'stop', An_leer: 'eject' },
  Pausieren: { Aus_mit_Tape: 'operate', Wiedergabe: 'play', Zurueckspulen_schnell: 'rewind', Vorspulen_schnell: 'fast_forward', An_mit_Tape: 'stop', An_leer: 'eject' },
  Zurueckspulen_normal: { Aus_mit_Tape: 'operate', Pausieren: 'pause', Wiedergabe: 'play', An_mit_Tape: 'stop', An_leer: 'eject' },
  Zurueckspulen_schnell: { Aus_mit_Tape: 'operate', An_mit_Tape: 'stop', An_leer: 'eject' },
  Vorspulen_schnell: { Aus_mit_Tape: 'operate', An_mit_Tape: 'stop', An_leer: 'eject' },
  Vorspulen_normal: { Aus_mit_Tape: 'operate', Pausieren: 'pause', Wiedergabe: 'play', An_mit_Tape: 'stop', An_leer: 'eject' },
  Aufnahme_normal: { Aus_mit_Tape: 'operate', Aufnahme_automatisch: 'record', An_mit_Tape: 'stop', An_leer: 'eject', Pausieren_Aufnahme_normal: 'pause' },
  Aufnahme_automatisch: { Aus_mit_Tape: 'operate', An_mit_Tape: 'stop', An_leer: 'eject', Pausieren_Aufnahme_automatisch: 'pause' },
  Pausieren_Aufnahme_normal: { Aus_mit_Tape: 'operate', Aufnahme_normal: 'play', Aufnahme_automatisch: 'record', An_mit_Tape: 'stop', An_leer: 'eject' },
  Pausieren_Aufnahme_automatisch: { Aus_mit_Tape: 'operate', Aufnahme_automatisch: 'play', An_mit_Tape: 'stop', An_leer: 'eject' }
}

const Labels = {
  Aus_leer: 'OFF w/o Tape',
  An_leer: 'ON w/o Tape',
  An_mit_Tape: 'ON w/ Tape',
  Aus_mit_Tape: 'OFF w/ Tape',
  Wiedergabe: 'Playing tape',
  Pausieren: 'Paused',
  Zurueckspulen_normal: 'Rewind',
  Zurueckspulen_schnell: 'Fast Rewind',
  Vorspulen_schnell: 'Fast Forward',
  Vorspulen_normal: 'Forward',
  Aufnahme_normal: 'REC',
  Aufnahme_automatisch: 'AUTO REC',
  Pausieren_Aufnahme_normal: 'REC paused',
  Pausieren_Aufnahme_automatisch: 'Auto paused',
}

const App = () => {

  const [current, setCurrent] = useState(States['Aus_leer']);
  const [label, setLabel] = useState(Labels['Aus_leer']);

  // Sounds
  const [playAudio, {stop}] = useSound(playSound);
  const [playClick] = useSound(clickSound);
  const [playEject] = useSound(ejectSound);
  const [playTapeIn] = useSound(tapeInSound);
  const [playRewind] = useSound(rewindSound);
  const [playRewindFast] = useSound(rewindFastSound);
  const [playError] = useSound(errorSound);

  const transition = (to) => {
    console.log( 'New state:' + to );
    setCurrent( States[to]);
    setLabel( Labels[to]);
  }

  const StateChangeHandler = (action) => {
    
    let newState = Object.keys(current).find( key => current[key] === action);
    console.log('Avaliable States:' + Object.keys(current));

    if(!newState){
      console.log('No Transition!');
      playClick();
      playError();
      return;
    }

    console.log('Perform action:' + action);

    switch(action) {
      case 'operate':
        playClick();
        stop();
        return transition( newState );
      case 'tape_in':
        playTapeIn();  
        return transition( newState );
      case 'stop':
        playClick();  
        stop();
        return transition( newState );
      case 'eject':
        playClick();
        stop();
        playEject();  
        return transition( newState );
      case 'play':
        playClick();  
        playAudio();  
        return transition( newState );
      case 'pause':
        playClick();  
        stop();
        return transition( newState ); 
      case 'rewind':
        playClick();
        stop();
        playRewind();  
        return transition( newState ); 
      case 'fast_forward':
        playClick(); 
        stop(); 
        playRewindFast();  
        return transition( newState ); 
      case 'record':
        playClick();
        stop();
        return transition( newState ); 
      default:
        return;
    }

  }

  return (
    <div className="App">

      <div className="Top">
        <div className="Top__1"></div>
      </div>

      <div className="Middle">
        
        <Tape 
          showTape={ current === States.Aus_leer || current === States.An_leer } 
          onStateChange={StateChangeHandler} 
        />

        <Display 
          isOff={ current === States.Aus_leer || current === States.Aus_mit_Tape } 
          output={ label }  
        />

        <div className="Brand">
          <img src={JVC_Logo} alt="JVC"/>
        </div>

        <ControlPanel onStateChange={ StateChangeHandler } />

      </div>

      <div className="Bottom">
        <div className="Bottom__3"></div>
        <div className="Bottom__2"></div>
        <div className="Bottom__1"></div>
      </div>

    </div>
    );

  }

export default App;



// WEBPACK FOOTER //
// ./src/App.js